
import { iconsImgs } from "../../utils/icons";
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "./AddFriends.scss";
import Header from "../Header";
import { Friendship } from "../../types"
import { useLocation } from 'react-router-dom';
import ModalImgInput from "../UserProfile/ModalImgInput";
import Gender from "../../api/enums/Gender";
import AuthClient from "../../api/AuthClient";
import { uploadUserProfileImage } from "../../azureBlob/BlobStorageService";

const FriendsPhotos = () => {

    const [showModal, setShowModal] = useState(false);
    const [selectedFriendIndex, setSelectedFriendIndex] = useState<number | null>(null);
    const [selectedFriendPhotos, setSelectedFriendPhotos] = useState<Record<number, File>>({});
    const [uploadingFriends, setUploadingFriends] = useState<Record<number, boolean>>({});
    const [uploadErrors, setUploadErrors] = useState<Record<number, string>>({});
    const handleCloseModal = () => setShowModal(false);
    const [friendsState, setFriendsState] = useState<Friendship>({
        Friends: [],
        GroupId: "",
    });

    const location = useLocation();
    const { inputs } = location.state;

    const navigate = useNavigate();
    const isUploading = Object.values(uploadingFriends).some(Boolean);

    const handleEditProfileClick = () => {
        if (friendsState.Friends.length > 0 && !isUploading) {
            navigate("/friendsAge", {
                state: { friendsState }
            });
        }
    };

    useEffect(() => {
        if (inputs.Friends.length > 0) {
            setFriendsState({
                Friends: inputs.Friends,
                GroupId: inputs.GroupId,
            });
        }
    }, [inputs.Friends, inputs.GroupId])

    const handleOpenPhotoModal = (friendIndex: number) => {
        if (uploadingFriends[friendIndex]) {
            return;
        }

        setSelectedFriendIndex(friendIndex);
        setShowModal(true);
    };

    const handleFriendNameChange = (event: ChangeEvent<HTMLInputElement>, friendIndex: number) => {
        const { value } = event.target;

        setFriendsState((prevFriendsState) => {
            const updatedFriends = [...prevFriendsState.Friends];
            updatedFriends[friendIndex] = {
                ...updatedFriends[friendIndex],
                FirstName: value,
            };

            return {
                ...prevFriendsState,
                Friends: updatedFriends,
            };
        });
    };

    const handleFriendImageSelected = async (file: File) => {
        if (selectedFriendIndex === null) {
            return;
        }

        const friendIndex = selectedFriendIndex;
        const selectedFriend = friendsState.Friends[friendIndex];

        if (!selectedFriend?.Id) {
            setUploadErrors((currentErrors) => ({
                ...currentErrors,
                [friendIndex]: "Missing profile ID for upload.",
            }));
            return;
        }

        setSelectedFriendPhotos((currentPhotos) => ({
            ...currentPhotos,
            [friendIndex]: file,
        }));
        setUploadErrors((currentErrors) => ({
            ...currentErrors,
            [friendIndex]: "",
        }));
        setUploadingFriends((currentUploadingFriends) => ({
            ...currentUploadingFriends,
            [friendIndex]: true,
        }));

        try {
            const authClient = new AuthClient();

            await uploadUserProfileImage({
                authClient,
                file,
                profileId: selectedFriend.Id,
                profileCount: 0,
                setAsProfilePhoto: true,
            });
        } catch (error) {
            console.error("Failed to upload friend photo:", error);
            setUploadErrors((currentErrors) => ({
                ...currentErrors,
                [friendIndex]: "Upload failed. Tap to try again.",
            }));
        } finally {
            setUploadingFriends((currentUploadingFriends) => ({
                ...currentUploadingFriends,
                [friendIndex]: false,
            }));
            setSelectedFriendIndex(null);
        }
    };

    return (
        <>
            <ModalImgInput showModal={showModal} handleCloseModal={handleCloseModal} onImageSelected={handleFriendImageSelected} />
            <Header />
            <div className="centerGroup">
                <div className="desktopUI">

                    {friendsState.Friends.length > 0 ? (
                        <>
                            <div className="row">
                                <div className="d-flex justify-content-start space col-6 mb-1">
                                    <button className='BtnTop yellowTxt btn backBtn' onClick={() => navigate(-1)}>Back</button>
                                </div>

                                <div className="d-flex justify-content-end col-6 space">
                                    <button className="BtnTop whiteTxt btn" onClick={handleEditProfileClick} disabled={isUploading} >
                                        Next
                                    </button>
                                </div>
                            </div>

                            <p className="d-flex yellowTxt justify-content-center _fp">
                                Friends Photos
                            </p>
                            <p className="d-flex yellowTxt justify-content-center">
                                It is highly recommended that you put photos on all guests
                            </p>

                            <div className="container">
                                {friendsState.Friends.map((item, index) => (
                                    <div key={index} className="friend-container" onClick={() => handleOpenPhotoModal(index)}>
                                        <div className="image-container">
                                            <img src={selectedFriendPhotos[index] ? URL.createObjectURL(selectedFriendPhotos[index]) : item.Gender === Gender.Female ? iconsImgs.Girl : iconsImgs.Boy} className="f_Img img_input" alt={`${item.FirstName} avatar`} />
                                        </div>
                                        <div className="content_ text-start">
                                            <input
                                                type="text"
                                                value={item.FirstName}
                                                onChange={(event) => handleFriendNameChange(event, index)}
                                                onClick={(event) => event.stopPropagation()}
                                                className="inp friend-name-input mb-1"
                                                placeholder="Enter first name"
                                                aria-label={`Friend ${index + 1} first name`}
                                            />
                                            <span className={uploadErrors[index] ? "redTxt txt_red" : "friend-photo-status"}>
                                                {uploadingFriends[index]
                                                    ? "Uploading photo..."
                                                    : uploadErrors[index]
                                                        ? uploadErrors[index]
                                                        : selectedFriendPhotos[index]
                                                            ? "Photo uploaded"
                                                            : "Tap to change photo"}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="container">
                                <button className="doneBtn yellowTxt" onClick={handleEditProfileClick} disabled={isUploading}>
                                    {isUploading ? "Uploading..." : "Next"}
                                </button>
                            </div>
                        </>
                    ) : (
                        <p>
                            No friends were found!
                        </p>
                    )}

                </div>
            </div>
        </>
    );
};

export default FriendsPhotos;
